<template>
  <div class="app-wrapper">
    <div class="app-wrapper" :style="{ '--current-color': theme }">
      <div
        v-if="device === 'mobile' && sidebar.opened"
        class="drawer-bg"
        @click="handleClickOutside"
      />
      <div
        :class="{
          'affix-container':
            (configurationData && configurationData.menuConfig == undefined) ||
            (configurationData && configurationData.menuConfig == null) ||
            (configurationData && configurationData.menuConfig == '') ||
            (configurationData && configurationData.menuConfig == 'vertical'),
          'affix-containere': configurationData.menuConfig == 'horizontal',
        }"
      >
        <navbar
          @setLayout="setLayout"
          v-if="
            (configurationData && configurationData.menuConfig == undefined) ||
            (configurationData && configurationData.menuConfig == null) ||
            (configurationData && configurationData.menuConfig == '') ||
            (configurationData && configurationData.menuConfig == 'vertical')
          "
          :configurationData="configurationData"
        />
        <navbar-sidebar
          @setLayout="setLayout"
          v-if="
            configurationData && configurationData.menuConfig == 'horizontal'
          "
          :configurationData="configurationData"
        />
      </div>
      <div
        :class="{ hasTagsView: needTagsView, sidebarHide: sidebar.hide }"
        class="main-container"
      >
        <sidebar
          v-if="
            !sidebar.hide &&
            ((configurationData && configurationData.menuConfig == undefined) ||
              (configurationData && configurationData.menuConfig == null) ||
              (configurationData && configurationData.menuConfig == '') ||
              (configurationData && configurationData.menuConfig == 'vertical'))
          "
          :configurationData="configurationData"
          class="sidebar-container"
        />
        <div
          :class="{
            'main-wrapper':
              (configurationData &&
                configurationData.menuConfig == undefined) ||
              (configurationData && configurationData.menuConfig == null) ||
              (configurationData && configurationData.menuConfig == '') ||
              (configurationData && configurationData.menuConfig == 'vertical'),
            'main-wrappere': configurationData.menuConfig == 'horizontal',
          }"
        >
          <div :class="{ 'fixed-header': fixedHeader }" class="main-content">
            <tags-view v-if="needTagsView" />
          </div>
          <app-main />
        </div>
      </div>
      <settings ref="settingRef" />
    </div>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import { set, useWindowSize } from "@vueuse/core";
import Sidebar from "./components/Sidebar/index.vue";
import {
  AppMain,
  Navbar,
  Settings,
  TagsView,
  NavbarSidebar,
} from "./components";
import defaultSettings from "@/settings";

import useUserStore from "@/store/modules/user";
import useAppStore from "@/store/modules/app";
import useSettingsStore from "@/store/modules/settings";

// 获取路由
const route = useRoute();

const userStore = useUserStore();
const settingsStore = useSettingsStore();
const theme = computed(() => settingsStore.theme);
const sideTheme = computed(() => settingsStore.sideTheme);
const sidebar = computed(() => useAppStore().sidebar);
const device = computed(() => useAppStore().device);
const needTagsView = computed(() => settingsStore.tagsView);
const fixedHeader = computed(() => settingsStore.fixedHeader);
const configurationData = ref({
  menuConfig: undefined,
});

const classObj = computed(() => ({
  hideSidebar: !sidebar.value.opened,
  openSidebar: sidebar.value.opened,
  withoutAnimation: sidebar.value.withoutAnimation,
  mobile: device.value === "mobile",
}));

const { width, height } = useWindowSize();
const WIDTH = 992; // refer to Bootstrap's responsive design

watchEffect(
  () => device.value,
  () => {
    if (device.value === "mobile" && sidebar.value.opened) {
      useAppStore().closeSideBar({ withoutAnimation: false });
    }
  }
);

watchEffect(() => {
  if (width.value - 1 < WIDTH) {
    useAppStore().toggleDevice("mobile");
    useAppStore().closeSideBar({ withoutAnimation: true });
  } else {
    useAppStore().toggleDevice("desktop");
  }
});

function handleClickOutside() {
  useAppStore().closeSideBar({ withoutAnimation: false });
}

const settingRef = ref(null);
function setLayout() {
  settingRef.value.openSetting();
}
function Configuration() {
  // userStore.getConfiguration();
  setTimeout(() => {
    configurationData.value = userStore.configurationData;
    // vertical
    // horizontal
    // configurationData.value.menuConfig = "vertical";
  }, 500);
}

Configuration();
</script>

<style lang="scss" scoped>
@import "@/assets/styles/mixin.scss";
@import "@/assets/styles/variables.module.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  background-color: rgba(244, 245, 248, 1);

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$base-sidebar-width});
  transition: width 0.28s;
}
.main-content {
  // margin-left: $base-sidebar-width;
}
#app .main-container {
  min-height: auto;
}
.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.sidebarHide .fixed-header {
  width: 100%;
}

.mobile .fixed-header {
  width: 100%;
}
.backgroundImage {
  width: 100%;
  height: 18.75rem;
  margin-top: 4.75rem;
}
.backgroundImage img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.affix-container {
  width: 100%;
  height: 3.5rem;
}
.affix-containere {
  width: 100%;
  height: 4em;
}
.main-wrapper {
  width: calc(100% - 14rem);
  height: 100%;
  margin-left: 15rem;
  // background-color: rgba(244, 245, 248, 1);
  overflow: hidden;
}
.main-wrappere {
  width: 100%;
  height: 100%;
  // margin-left: 15rem;
  // background-color: rgba(244, 245, 248, 1);
  overflow: hidden;
}
.main-wrappers {
  margin: 0;
  padding: 0;
}
</style>